import FlUtils from '../../utils/utils';
import BaseShopSystem from './base';

const Websale = (function () {
    /* Public */
    return {
        NAME: 'Websale',
        VERSION: 1,

        productParam: 'identifier',
        catParam: 'attrib[cat][]',
        vendorParam: 'attrib[vendor][]',

        /**
         * Appends shopsystem specific input fields to the form
         *
         * @param {JSON} item
         * @param {Object} form
         */
        appendSpecificItemsToForm(item, form) {
            // PRODUCT
            if (item.hasOwnProperty('identifier') && item.block === this.BLOCKS.PRODUCT) {
                this.appendInput(form, this.productParam, item.identifier);
            }

            // CAT
            if (item.hasOwnProperty('block') && item.block === this.BLOCKS.CAT) {
                this.appendInput(form, this.catParam, item.label);
            }

            // Vendor
            if (item.hasOwnProperty('block') && item.block === this.BLOCKS.VENDOR) {
                this.appendInput(form, this.vendorParam, item.label);
            }

            return this;
        },

        submitForm(form) {
            if (form.length === 1) {
                /* Set the form method to GET, otherwise the filter inputs will be discarded when submitting */
                form.attr('method', 'get');
                form.submit();
            } else {
                throw new Error("Form-submit isn't possible! The is more or less than one form-object available.");
            }
        },
    };
})();

FlUtils.extend(Websale, BaseShopSystem);
export default Websale;
